import i18n from 'i18next';
import { LanguageCodes } from '../common/types/i18n';

/**
 * Change the current language.
 * @param languageCode The language code to switch to (e.g., 'en', 'ar').
 */
export const switchLanguage = (languageCode: LanguageCodes) => {
  i18n.changeLanguage(languageCode);
};
